import type { CheckoutFields } from './schema'
import type { CheckoutForm } from './useCheckoutForm'

export const toE164 = (phone: string): string => {
  const digits = phone.replace(/\D/g, '')
  return digits.startsWith('1') ? `+${digits}` : `+1${digits}`
}

export const safeStorage = <T>(fn: () => T): T | undefined => {
  try {
    return fn()
  } catch {
    return undefined
  }
}

type FieldErrorSource = {
  getFieldErrorMessage(key: string): string | undefined
}

export const applyApiFieldErrors = (
  form: CheckoutForm,
  apiErr: FieldErrorSource,
  fieldMap: Record<string, keyof CheckoutFields>,
): boolean => {
  let mapped = false
  for (const [apiField, formField] of Object.entries(fieldMap)) {
    const msg = apiErr.getFieldErrorMessage(apiField)
    if (!msg) continue
    mapped = true
    form.setFieldMeta(formField, (m) => ({
      ...m,
      errorMap: { ...m.errorMap, onChange: { message: msg } },
    }))
  }
  return mapped
}

export const setFieldError = (
  form: CheckoutForm,
  field: keyof CheckoutFields,
  message: string,
): void => {
  form.setFieldMeta(field, (m) => ({
    ...m,
    errorMap: { ...m.errorMap, onChange: { message } },
  }))
}
